import Universal from './universal';
import Language from './language';
import Forms from './forms';
import Rectifiers from './rectifiers';
import Users from './users';
import Filters from './filters';
import Cuadros from './cuadros';
import Groups from './groups';
import Disponibilidad from './disponibilidad';
import Variables from './variables';
import Comandos from './comandos';
import Notificaciones from './notificaciones';
import Reportes from './reportes';
import Maestros from './maestros';

export default {
  Universal,
  Language,
  Forms,
  Rectifiers,
  Users,
  Filters,
  Cuadros,
  Groups,
  Disponibilidad,
  Variables,
  Comandos,
  Notificaciones,
  Reportes,
  Maestros,
};
